"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _includes = _interopRequireDefault(require("lodash/includes"));

var _table = _interopRequireDefault(require("antd/lib/table"));

var _Util = require("../../../../components/util/Util");

var selectors = _interopRequireWildcard(require("../../../../redux/selectors"));

var _SearchInput = _interopRequireDefault(require("../../../../components/search/SearchInput"));

require("./participantSearch.scss");

var _Username = _interopRequireDefault(require("../../../../components/username/Username"));

var _participants = require("../../../../redux/participants/participants.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {
  searchString: '',
  armFilterId: 0,
  filtersCollapsed: false
};

const renderParticipantLink = (value, row) => {
  return /*#__PURE__*/_react.default.createElement(_Username.default, {
    participantId: row.id
  });
};

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class ParticipantSearch extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.handleSearchStringChange = event => {
      const value = event.currentTarget.value.toString();
      this.setState({
        searchString: value
      });
    };

    this.handleArmFilterChange = event => {
      const value = event.target.value;
      this.setState({
        armFilterId: value
      });
    };

    this.renderStudyArm = value => {
      const {
        study
      } = this.props;

      if (value && study) {
        const arm = study.studyArms.find(sa => sa.id === value);
        return arm ? arm.name : value;
      }
    };

    this.studyArmFilters = () => {
      const {
        study
      } = this.props;

      if (study) {
        return study.studyArms.map(arm => {
          return {
            text: arm.name,
            value: arm.id
          };
        });
      }

      return [];
    };

    this.handleRowClick = record => {
      if (record && record.id) {
        const {
          studyId
        } = this.props;
        this.props.history.push(`/study/${studyId}/participants/${record.id}`);
      }
    };

    this.renderFirstNameLink = (value, row) => {
      const {
        studyId
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/participants/${row.id}`
      }, value);
    };
  }

  componentDidMount() {
    this.props.getParticipantsByStudy(this.props.studyId);
  }

  render() {
    const studyArmFilters = this.studyArmFilters();
    const columns = [{
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id
    }, {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      render: renderParticipantLink,
      sorter: (a, b) => `${a.username}`.localeCompare(b.username),
      filters: [{
        text: 'Unenrolled',
        value: 'Unenrolled'
      }],
      onFilter: (value, record) => value === 'Unenrolled' && _.isEmpty(record.username)
    }, {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: this.renderFirstNameLink,
      sorter: (a, b) => `${a.firstName}`.localeCompare(b.firstName)
    }, {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => `${a.email}`.localeCompare(b.email)
    }, {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
      sorter: (a, b) => `${a.mobile}`.localeCompare(b.mobile)
    }, {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: _Util.renderDateWithoutTime,
      sorter: (a, b) => (0, _moment.default)(a.startDate).unix() - (0, _moment.default)(b.startDate).unix(),
      defaultSortOrder: 'descend'
    }, {
      title: 'Study Arm',
      dataIndex: 'studyArmId',
      key: 'studyArmId',
      render: this.renderStudyArm,
      filters: studyArmFilters,
      onFilter: (value, record) => record.studyArmId === value
    }];
    const {
      searchString,
      armFilterId,
      filtersCollapsed
    } = this.state;
    const {
      loadStudyStatus,
      study,
      participants
    } = this.props;

    if (loadStudyStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading");
    }

    if (loadStudyStatus.isError) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error Loading the Study");
    }

    if (!study) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Study was not loaded");
    }

    const searchParticipants = searchString === '' ? participants : participants === null || participants === void 0 ? void 0 : participants.filter(participant => {
      return Object.values(participant).some(property => (0, _includes.default)(property ? property.toString().toLowerCase() : '', searchString.toLowerCase()));
    });
    const filteredParticipants = armFilterId === 0 ? searchParticipants : searchParticipants === null || searchParticipants === void 0 ? void 0 : searchParticipants.filter(participant => {
      return participant.studyArmId === armFilterId;
    });
    const filterHeight = filtersCollapsed ? 275 : 350;
    return /*#__PURE__*/_react.default.createElement(_card.default, {
      id: "participant-search",
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "table-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Participants"))
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table-filter-search"
    }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
      className: "search-bar",
      id: "search-input",
      onChangeHandler: this.handleSearchStringChange,
      placeholder: "Search Participants",
      value: searchString
    })), /*#__PURE__*/_react.default.createElement("div", {
      id: "search-results-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: '0 0 auto',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_table.default, {
      scroll: {
        y: `calc(100vh - ${filterHeight}px)`
      },
      columns: columns,
      dataSource: filteredParticipants,
      rowClassName: rowClassName,
      pagination: {
        defaultPageSize: 20,
        pageSizeOptions: ['20', '50', '100'],
        position: ['bottomRight']
      },
      tableLayout: "fixed",
      style: {
        height: 663
      },
      rowKey: "id",
      onRow: (record, rowIndex) => {
        return {
          onClick: event => this.handleRowClick(record),
          onDoubleClick: event => {},
          onContextMenu: event => {},
          onMouseEnter: event => {},
          onMouseLeave: event => {} // mouse leave row

        };
      }
    }))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  loadStudyStatus: selectors.loadStudyStatus,
  study: selectors.getRequestedStudy,
  participants: selectors.getParticipants,
  studyId: selectors.getRequestedStudyId
});

const mapDispatchToProps = dispatch => {
  return {
    getParticipantsByStudy: studyId => dispatch(_participants.getParticipantsByStudyAsync.request(studyId))
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ParticipantSearch));

exports.default = _default;